<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="类型：" prop="type">
                <span>{{ transEnu(model.type, "record_type")}}</span>
            </el-form-item>
            <el-form-item label="内容：" prop="title">
                <span>{{model.title}}</span>
            </el-form-item>
            <el-form-item label="时间：" prop="type">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'recordInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                title: '',
                type: '',
            },
            getObj:{
                url:'/api/admin/record/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['record_type'],
        };
    },
    methods: {}
};
</script>